import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SocialSparkline } from '../SocialSparkline';
import { updatedAgo } from '../updatedAgo';
import { SocialPlatform } from '../types';
import { channelNumbersMessages as messages } from './channelNumbersMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelGrowthLineProps {
  platform: SocialPlatform;
  /** The follower count of each day that has one, oldest first. */
  values: number[];
  /** The period of the line in days: 28, or 7 on Free. */
  periodDays: number;
  /** ISO 8601. The end of the last daily read. */
  lastSyncedAt: string | null;
  /** The sign-in ended: the numbers are old, so the line is grey. */
  dim: boolean;
}

/** The small growth line of a channel card, with its period and the age of the last read. */
const ChannelGrowthLineComponent: React.FC<ChannelGrowthLineProps> = ({
  platform,
  values,
  periodDays,
  lastSyncedAt,
  dim,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.growth}>
      <SocialSparkline values={values} dim={dim} gradientId={`channel-growth-${platform}`} />
      <div className={styles.growthCaption}>
        <span>{intl.formatMessage(messages.period, { days: periodDays })}</span>
        {lastSyncedAt === null ? null : (
          <span>{intl.formatMessage(messages.updated, { time: updatedAgo(intl, lastSyncedAt) })}</span>
        )}
      </div>
    </div>
  );
};

export const ChannelGrowthLine = TypedMemo(ChannelGrowthLineComponent);
